/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_RequestedInputs */

const vi_carrier_return_requested = /** @type {(inputs: Carrier_Return_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng yêu cầu chuyển hoàn — cần phản hồi duyệt hoàn hoặc phát lại với hãng`)
};

/**

* @param {Carrier_Return_RequestedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_requested = /** @type {((inputs?: Carrier_Return_RequestedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_RequestedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_requested(inputs)
});